<template>
  <div class="page">
    <div>
      <div class="filter-bar">
        <span @click="selectYear">
          年份 {{ year }}
          <i class="caret"></i>
        </span>
      </div>
      <div class="filter-row">
        <div class="filter-info">
          <div class="filter-select">
            <mixed-work-hour
              label=""
              v-model="querytype"
              @change="searchText"
            />
          </div>
          <div class="filter-input">
            <project-field
              v-if="querytype == '项目'"
              label=""
              v-model="form.pj_dename"
              @select="onSelectPjoct($event)"
            />
            <employee-field
              label=" "
              v-if="querytype == '人员'"
              v-model="form.em_name"
              @select="onselectSeller($event)"
            />
            <department-field
              v-if="querytype == '部门'"
              label=""
              v-model="form.dp_name"
              @select="onSelectDepartment($event)"
            />
          </div>
        </div>
      </div>

      <div class="canvas-box">
        <canvas id="myChart" class="myChart"></canvas>
        <div class="list-empty" v-if="!result.monthitems">暂无数据</div>
      </div>

      <div
        class="list-container"
        v-if="querytype == '全部' && result.monthitems"
      >
        <div class="list-fixed">
          <p class="list-box-col__title">月份</p>
          <p
            class="list-box-col__content"
            v-for="(item,index) in textArr"
            :key="index"
          >
            {{ item }}
          </p>
          <p class="list-box-col__content">本年累计</p>
        </div>
        <div class="list-scroll">
          <div class="list-scroll-wrap">
            <div
              class="list-box-col"
              @click="initChart(deal2(result.details[0]))"
            >
              <p class="list-box-col__title">标准工时</p>
              <p
                class="list-box-col__content"
                style="color: #2eadf5"
                v-for="(item, index1) in list1"
                :key="index1"
              >
                {{ numberFormat(item.value, "#,##0.##") || 0 }}
              </p>
              <p class="list-box-col__content" style="color: #2eadf5">
                {{
                  numberFormat(result.details[0].standtotal, "#,##0.##") || 0
                }}
              </p>
            </div>
            <div
              class="list-box-col"
              @click="initChart(deal2(result.details[0]))"
            >
              <p class="list-box-col__title">实际工时</p>
              <p
                class="list-box-col__content"
                style="color: #2eadf5"
                v-for="(item, index2) in list2"
                :key="index2"
              >
                {{ numberFormat(item.value, "#,##0.##") || 0 }}
              </p>
              <p class="list-box-col__content" style="color: #2eadf5">
                {{ numberFormat(result.details[0].acttotal, "#,##0.##") || 0 }}
              </p>
            </div>
            <div
              class="list-box-col"
              @click="initChart(deal2(result.details[0]))"
            >
              <p class="list-box-col__title">工时成本</p>
              <p
                class="list-box-col__content"
                style="color: #2eadf5"
                v-for="(item, index3) in list3"
                :key="index3"
              >
                {{ numberFormat(item.value, "#,##0.##") || 0 }}
              </p>
              <p class="list-box-col__content" style="color: #2eadf5">
                {{ numberFormat(result.details[0].wagetotal, "#,##0.##") || 0 }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="list-cells" v-if="querytype != '全部' && result.details">
        <div
          class="list-cell"
          v-for="(item, index) in result.details"
          :key="index"
        >
          <div class="list-cell__main" @click="open(index)">
            <div class="list-cell__index">
              <span>{{ index + 1 }}</span>
            </div>
            <div class="list-cell__content">
              <p v-if="querytype == '项目'">{{ item.ta_pjcode }}</p>
              <p v-if="querytype == '部门'">
                {{ item.dp_name }}
              </p>
              <p v-if="querytype == '人员'">
                {{ item.ta_emname }}
              </p>
              <p>标准/实际/成本 {{ numberFormat(item.standtotal, "#,##0.##") || 0 }} / {{ numberFormat(item.acttotal, "#,##0.##") || 0 }} / {{ numberFormat(item.wagetotal, "#,##0.##") || 0 }}</p>
            </div>
            <div class="list-cell__toggle">
              <span v-if="opened == index"
                ><i class="iconfont icon-shang"></i
              ></span>
              <span v-else><i class="iconfont icon-xia"></i></span>
            </div>
          </div>
          <div class="weui-cells" v-if="opened == index">
            <div
              class="weui-cell gray"
              v-for="(month, indexs) in textArr"
              :key="indexs"
            >
              <div class="weui-cell__bd">{{ month }}</div>
              <div
                class="weui-cell__ft"
                style="font-size: 12px"
                v-if="indexs < 12"
              >
                {{
                  numberFormat(item["standhour" + (indexs + 1)], "#,##0.##") || 0
                }} / 
                 {{
                  numberFormat(item["acthour" + (indexs + 1)], "#,##0.##") || 0
                }} / 
                 {{
                  numberFormat(item["wage" + (indexs + 1)], "#,##0.##") || 0
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import F2 from "@antv/f2/lib/index";
import MixedWorkHour from "@/components/field/MixedWorkHour.vue";
import ProjectField from "@/components/field/ProjectField.vue";
import DepartmentField from "@/components/field/DepartmentField.vue";
import EmployeeField from "@/components/field/EmployeeField.vue";
import ScrollBar from "@antv/f2/lib/plugin/scroll-bar";
import "@antv/f2/lib/interaction/pan";

export default {
  components: {
    MixedWorkHour,
    ProjectField,
    DepartmentField,
    EmployeeField,
  },
  data() {
    let year = new Date().getFullYear();
    return {
      result: {},
      opened: -1,
      chart: null,
      condition: null,
      querytype: "全部",
      querytypeObj: {
        全部: "detail",
        项目: "proj",
        部门: "dept",
        人员: "empl",
      },
      con: "全部",
      form: {
        pj_dename: null,
        dp_name: null,
        em_name: null,
      },
      year,
      textArr: [
        "1月",
        "2月",
        "3月",
        "4月",
        "5月",
        "6月",
        "7月",
        "8月",
        "9月",
        "10月",
        "11月",
        "12月",
      ],
      list1: [],
      list2: [],
      list3: [],
    };
  },
  mounted() {
    this.searchWorkHour();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    clear() {
      this.form = {
        pj_dename: null,
        dp_name: null,
        em_name: null,
      };
    },
    selectYear() {
      var me = this,
        year = new Date().getFullYear(),
        years = [];
      for (let i = year - 20; i <= year + 20; i++) {
        years.push({
          value: i,
          label: i + "年",
        });
      }
      me.$weui.picker(years, {
        title: "选择年份",
        defaultValue: [year],
        onConfirm: function (r) {
          me.year = r[0].value;
          me.searchWorkHour();
        },
      });
    },
    onSelectPjoct(selection) {
      this.form.pj_dename = selection.pr_detail;
      this.condition = "pj_dename  like '%" + selection.pj_dename + "%'";
      this.searchWorkHour();
    },
    onselectSeller(selection) {
      this.form.em_name = selection.em_name;
      this.condition = "ta_emname like '%'" + selection.em_name +"%''";
      this.searchWorkHour();
    },
    onSelectDepartment(selection) {
      this.form.dp_name = selection.dp_name;
      this.condition = "dp_name like '%'" + selection.dp_name +"%''";
      this.searchWorkHour();
    },
    searchText() {
      this.clear();
      this.condition = null;
      this.searchWorkHour();
    },
    getCol() {
      let me = this,
        result = me.result,
        d = result.details[0];
        me.list1 = [];
        me.list2 = [];
        me.list3 = [];
      for (let i = 0; i < 12; i++) {
        me.list1.push({
          text: me.textArr[i],
          value: d["standhour" + (i + 1)],
        });
        me.list2.push({
          text: me.textArr[i],
          value: d["acthour" + (i + 1)],
        });
        me.list3.push({
          text: me.textArr[i],
          value: d["wage" + (i + 1)],
        });
      }

    },
    searchWorkHour() {
      let me = this,
        condition = me.condition,
        querytype = me.querytypeObj[me.querytype];
      let params = {
        year: me.year,
        querytype: querytype,
        con: condition
          ? JSON.stringify([{ type: "condition", value: condition }])
          : null,
      };

      me.$ajax({
        url: "/api/plm/report/projectHoursAnalyze",
        params,
      }).then(function (res) {
        if (res.success) {
          me.result = res.data;
          me.getCol();
          me.initChart(me.deal(me.result.monthitems));
        }
      });
    },
    searchPurcsale() {
      let me = this,
        querytype = me.querytypeObj[me.querytype];
      let searchBar = me.$refs.searchBar;
      let keyword = searchBar.keyword;

      let params = {
        year: me.year,
        querytype: querytype || "detail",
        condition: [],
      };
      if (keyword) {
        params.condition.push({
          type: "condition",
          value: `(upper(pr_orispeccode) like '%${keyword}%' or upper(pr_code) like '%${keyword}%' or upper(pr_detail) like '%${keyword}%')`,
        });
      }
      params.condition = JSON.stringify(params.condition);

      me.$ajax({
        url: "/api/plm/report/projectHoursAnalyze",
        params,
      }).then(function (res) {
        if (res.success) {
          me.result = res.data;
          me.getCol();
          me.initChart(me.deal(me.result.monthitems));
        }
      });
    },
    open(index) {
      if (index != this.opened) {
        this.initChart(this.deal2(this.result.details[index]));
      }
      this.opened = index == this.opened ? -1 : index;
    },
    deal2(data) {
      let me = this;
      if (!data) return;

      let arr = [];

      for (let i = 0; i < 12; i++) {
        arr.push(
          {
            index: i,
            text: me.textArr[i],
            type: "标准工时",
            value: data["standhour" + (i + 1)] || 0,
          },
          {
            index: i,
            text: me.textArr[i],
            type: "实际工时",
            value: data["acthour" + (i + 1)] || 0,
          }
        );
      }
      return arr;
    },
    onResize() {
      var chart = this.chart;
      if (chart) {
        this.chart = chart.destroy();
        this.initChart(this.deal(this.result.monthitems));
      }
    },
    initChart(data) {
      var chart = this.chart;
      if (chart) {
        chart.changeData(data);
        return;
      }
      this.chart = chart = new F2.Chart({
        id: "myChart",
        width: window.innerWidth,
        height: Math.min(window.innerHeight * 0.6, 300),
        pixelRatio: window.devicePixelRatio,
        plugins: ScrollBar,
      });

      chart.source(data, {
        index: {
          type: "linear",
          tickInterval: 1,
          min: -1,
          max: window.innerWidth > window.innerHeight ? 12 : 6,
          formatter: (i) =>
            i > -1 && i < 12
              ? [
                  "01月",
                  "02月",
                  "03月",
                  "04月",
                  "05月",
                  "06月",
                  "07月",
                  "08月",
                  "09月",
                  "10月",
                  "11月",
                  "12月",
                ][i]
              : null,
        },
      });
      chart
        .interval()
        .position("index*value")
        .color("type", (val) => {
          if (val === "标准工时") {
            return "#2eadf5";
          } else if (val === "实际工时") {
            return "#e44959";
          }
        })
        .adjust({
          type: "dodge",
          marginRatio: 0.05,
        });
      if (window.innerWidth < window.innerHeight) {
        // 定义进度条
        chart.scrollBar({
          mode: "x",
          xStyle: {
            backgroundColor: "#e8e8e8",
            fillerColor: "#808080",
            offsetY: -2,
          },
        });
      }
      chart.interaction("pan");
      chart.render();
    },
    deal(data) {
      if (!data) return;

      const textArr = [
        "01月",
        "02月",
        "03月",
        "04月",
        "05月",
        "06月",
        "07月",
        "08月",
        "09月",
        "10月",
        "11月",
        "12月",
      ];

      let arr = [
        { index: -1, type: "标准工时", value: 0 },
        { index: 12, type: "实际工时", value: 0 },
      ];
      data.forEach((item, i) => {
        arr.push(
          {
            text: item.text,
            type: "标准工时",
            index: i,
            value: item.standhours,
          },
          {
            text: item.text,
            type: "实际工时",
            index: i,
            value: item.acthours,
          }
        );
      });
      const l = arr.length / 3;
      if (l < 12) {
        for (let i = l; i < 12; i++) {
          arr.push(
            {
              index: i,
              text: textArr[i],
              type: "标准工时",
              value: 0,
            },
            {
              index: i,
              text: textArr[i],
              type: "实际工时",
              value: 0,
            }
          );
        }
      }
      return arr;
    },
  },
};
</script>

<style scoped>
.list-empty {
  width: 100%;
  height: 200px;
  line-height: 200px;
  text-align: center;
  background: #fff;
  color: #8b8b8b;
  font-size: 12px;
}

.filter-row {
  width: 100%;
  padding: 1px 0px;
  background: #fff;
  /* height: 70px; */
}
.filter-info {
  /* height: 58px; */
  background-color: #fff;
  margin: 10px;
  display: flex;
  flex-direction: row;
  border-radius: 10px;
  justify-content: space-between;
  border: 1px solid var(--weui-FG-3);
}

.filter-select {
  width: 110px;
}
.filter-input {
  flex: 1;
}

.canvas-box {
  /* width: 100%;
  height: 100%; */
  overflow-x: scroll;
  background: var(--weui-BG);
}

.filter-bar {
  width: 100%;
  background: var(--weui-BG-2);
  box-sizing: border-box;
  text-align: center;
  font-size: 13px;
  padding: 11px 0 9px 0;
  color: #9b9b9b;
  margin-bottom: 1px;
  display: flex;
}
.filter-bar span {
  margin: 0 auto;
  flex: 1;
  position: relative;
}
.filter-item__select {
  position: absolute;
  margin: 0;
  padding: 0;
  border: 0;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.filter-item__select option {
  color: var(--weui-FG-0);
  background: var(--weui-BG-2);
}

.list-container {
  text-align: center;
  line-height: 40px;
  background: var(--weui-BG);
  display: flex;
  width: 100%;
}
.list-fixed {
  width: 100px;
  border-right: 1px solid var(--weui-FG-3);
}
.list-scroll {
  flex: 1;
  /* overflow-y: scroll; */
}
.list-scroll-wrap {
  display: flex;
  flex: 1;
}
.list-box-col:active {
  background: #e0e0e0;
}
.list-box-col__title {
  width: 70px;
  font-size: 14px;
  font-weight: bold;
}
.list-box-col > .list-box-col__title {
  width: 100px;
}
.list-box-col__content {
  font-size: small;
  color: var(--weui-FG-0);
}

.list-cells {
  margin-top: 5px;
  background: var(--weui-BG);
}
.list-cell {
  background-color: #fff;
}
.list-cell__main {
  display: flex;
  padding: 10px 0;
}
.list-cell__index {
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.list-cell__index span {
  border-radius: 50%;
  width: 20px;
  height: 20px;
  color: #fff;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  background-color: #c0c0c0;
}
.list-cell__content {
  flex: 1;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  color: #8b8b8b;

  display: flex;
  justify-content: space-between;

  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.list-cell__toggle {
  width: 36px;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  padding: 0 0px 0 20px;
}
.gray {
  /* max-height: 300px;
  overflow-y: auto; */
  background: #f4f4f4;
}
@media screen and (min-width: 500px) {
  .filter-bar {
    padding: 6px 0 2px 0;
  }
  .list-scroll-wrap {
    width: 100%;
  }
  .list-container {
    line-height: 25px;
  }
  .filter-row {
    display: none;
  }
}
</style>